import { handleResponse, authHeader } from '../helpers'

export const blogCustomSendingDomainService = {
    get,
    connect,
    verify,
    disconnect,
}

function get () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/blog/custom-sending-domain/`, requestOptions).then(handleResponse)
}

function connect (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/blog/custom-sending-domain/`, requestOptions).then(handleResponse)
}
function verify (domainName) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/blog/custom-sending-domain/${domainName}`, requestOptions).then(handleResponse)
}
function disconnect () {
    const requestOptions = {
        method: 'DELETE',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    }
    return fetch(`/blog/custom-sending-domain/`, requestOptions).then(handleResponse)
}
